const XML_ESCAPE_MAP = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&apos;',
};

const XML_UNESCAPE_MAP = {
	'&amp;': '&',
	'&lt;': '<',
	'&gt;': '>',
	'&quot;': '"',
	'&apos;': "'",
};

const TO_ESCAPE = /[&<>"']/g;
const TO_UNESCAPE = /&(?:amp|lt|gt|quot|apos);/g;

const doEscape = (ch: string) => XML_ESCAPE_MAP[ch as keyof typeof XML_ESCAPE_MAP];
const doUnEscape = (ch: string) => XML_UNESCAPE_MAP[ch as keyof typeof XML_UNESCAPE_MAP];

export const escapeXML = (s: string): string => s.replace(TO_ESCAPE, doEscape);
export const unescapeXML = (s: string): string => s.replace(TO_UNESCAPE, doUnEscape);

export const Escape = {
	escape: escapeXML,
	unescape: unescapeXML,
};
